import React from 'react';

import { Container } from './styles';

const FeaturedContent = ({ slideInfo: { index }, items }) => (
  <Container>
    {items?.map((item, imageIndex) => (
      <img
        src={item?.featuredImage?.image?.file?.url}
        className={`${index === imageIndex ? 'active' : 'inactive'}`}
      />
    ))}
  </Container>
);

export default FeaturedContent;
